import { render, staticRenderFns } from "./ComprasDiretasEmAndamento.vue?vue&type=template&id=860d29c6&scoped=true"
import script from "./ComprasDiretasEmAndamento.vue?vue&type=script&lang=js"
export * from "./ComprasDiretasEmAndamento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "860d29c6",
  null
  
)

export default component.exports